module.exports = __webpack_public_path__ + "img/dropdown-search-hyundai.ac8e5e7b.png";